import { useSusSectionPending } from '@bz/request';

import {
  Banner,
  PageSwitch,
  HomeSports,
  HomeLive,
  HomeUpcoming,
  HomeMyFavorite,
  HomeMyBets,
  ActivityPop,
} from '~/components/lobby';

export const route = {
  preload: () => {},
} satisfies RouteDefinition;

const Home = () => {
  const [selectedTab, setSelectedTab] = createSignal('sports-home');

  const { pending } = useSusSectionPending({
    trigger: () => selectedTab() && selectedTab() !== 'my-favorite',
  });

  return (
    <main class="mx-auto flex flex-col gap-6 pt-3">
      <Banner />
      <ActivityPop />
      <PageSwitch onTabChange={setSelectedTab} />
      <Suspense fallback={<BarLoading class="size-14 !mb-[100vh]" />}>
        {pending()}
        <Switch>
          <Match when={selectedTab() === 'sports-home'}>
            <HomeSports />
          </Match>
          <Match when={selectedTab() === 'live-events'}>
            <HomeLive />
          </Match>
          <Match when={selectedTab() === 'upcoming'}>
            <HomeUpcoming />
          </Match>
          <Match when={selectedTab() === 'my-favorite'}>
            <HomeMyFavorite />
          </Match>
          <Match when={selectedTab() === 'my-bets'}>
            <HomeMyBets />
          </Match>
        </Switch>
      </Suspense>
    </main>
  );
};

export default Home;
